<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="规则名称">
          <el-input
            v-model="searchData.ruleName"
            placeholder="请输入"
            size="small"
            clearable
            class="search-form-item"
          />
        </el-form-item>
        <el-form-item label="规则类型">
          <el-select
            v-model="searchData.ruleType"
            placeholder="请选择"
            size="small"
            clearable
            class="search-form-item"
          >
            <el-option
              v-for="item in dict.MachineRuleTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select
            v-model="searchData.status"
            placeholder="全部"
            size="small"
            clearable
            class="search-form-item"
          >
            <el-option label="启用" :value="true" />
            <el-option label="禁用" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search"
            >搜索</el-button
          >
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <el-button
      v-checkbtn="isShowBtn(AUTH_BTN.review_machine_rule_add)"
      style="margin-bottom: 20px"
      type="primary"
      icon="el-icon-plus"
      size="small"
      @click="$router.push({ name: 'ReviewMachineRuleAdd' })"
      >新增规则</el-button
    >
    <tp-table
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  EnumMachineRuleType,
  MachineRuleTypeList,
  MachineRuleTypeToTextMap,
  getMachineRuleTypeColor,
} from "@/enum/dict/machine-rule.js";
import {
  getMachineRuleListAPI,
  changeMachineRuleStatusAPI,
  getMachineRuleStatusPrecheckAPI,
} from "./api";

const columns = [
  {
    label: "规则名称",
    prop: "ruleName",
    minWidth: "200",
    customRender(h, row) {
      return <p>{row["ruleName"]}</p>;
    },
  },
  {
    label: "规则类型",
    prop: "ruleType",
    minWidth: "130",
    customRender(h, row) {
      const text = MachineRuleTypeToTextMap.get(row["ruleType"]);
      if (!text) return <p>-</p>;
      const { color, background } = getMachineRuleTypeColor(row["ruleType"]);
      return (
        <el-tag
          color={background}
          style={`color:${color};border-color:${background};font-weight:600`}
        >
          {text}
        </el-tag>
      );
    },
  },
  {
    label: "命中首付比",
    prop: "prepayRate",
    minWidth: "110",
    customRender(h, row) {
      const hasRate =
        row["ruleType"] === EnumMachineRuleType.BASE && row["prepayRate"] != null;
      return <p>{hasRate ? `${row["prepayRate"]}%` : "-"}</p>;
    },
  },
  {
    label: "创建时间",
    prop: "createTime",
    minWidth: "160",
    customRender(h, row) {
      return <p>{row["createTime"]}</p>;
    },
  },
  {
    label: "是否启用",
    prop: "status",
    minWidth: "120",
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={
              !this.isShowBtn(this.AUTH_BTN.review_machine_rule_status)
            }
            class="switch"
            onChange={() => this.changeStatus(row)}
            v-model={row["status"]}
            active-value={true}
            inactive-value={false}
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      );
    },
  },
  {
    label: "操作",
    minWidth: "120",
    fixed: "right",
    customRender(h, row) {
      return (
        <div>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.review_machine_rule_detail)}
            underline={false}
            type="primary"
            onClick={() =>
              this.$router.push({
                name: "ReviewMachineRuleDetail",
                params: { id: row["id"] },
              })
            }
          >
            详情
          </el-link>
          <el-link
            style="margin-left:10px;"
            disabled={
              !this.isShowBtn(this.AUTH_BTN.review_machine_rule_edit) ||
              row["status"]
            }
            underline={false}
            type="primary"
            onClick={() =>
              this.$router.push({
                name: "ReviewMachineRuleEdit",
                params: { id: row["id"] },
              })
            }
          >
            编辑
          </el-link>
        </div>
      );
    },
  },
];

export default {
  name: "ReviewMachineRuleList",
  mixins: [authBtnMixin],

  data() {
    return {
      columns,
      dict: { MachineRuleTypeList },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        ruleName: undefined,
        ruleType: undefined,
        status: undefined,
      },
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  activated() {
    this.getList();
  },
  methods: {
    search() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getList();
    },
    async getList() {
      const { ruleName, ruleType, status } = this.searchData;
      const res = await getMachineRuleListAPI({
        page: this.currentPage,
        pageSize: this.pageSize,
        ruleName,
        ruleType,
        status: typeof status === "boolean" ? status : undefined,
      });
      this.list = (res.list || []).map((row) => ({
        ...row,
        // 兼容接口返回字符串类型码。
        ruleType: Number(row.ruleType),
      }));
      this.total = res.total || 0;
    },
    async changeStatus(row) {
      // el-switch 已通过 v-model 写入目标状态。
      const target = row.status;

      // 人工干预直接切换，其余类型先预检并按需确认。
      if (row.ruleType === EnumMachineRuleType.MANUAL) {
        this.submitStatus(row, target, this.statusTip(row, target));
        return;
      }

      let tip = "";
      try {
        tip = await this.confirmTip(row, target);
      } catch {
        row.status = !target;
        return;
      }

      if (tip) {
        try {
          await this.$confirm(tip, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        } catch {
          row.status = !target;
          this.$message({ type: "info", message: "已取消操作" });
          return;
        }
      }

      await this.submitStatus(row, target, this.statusTip(row, target));
    },
    statusTip(row, status) {
      const subject =
        row.ruleType === EnumMachineRuleType.BASE
          ? `${row.prepayRate}%档位`
          : `「${row.ruleName}」`;
      return `${subject}规则已${status ? "启用" : "停用"}，仅对新订单生效`;
    },
    confirmSubject(row) {
      return row.ruleType === EnumMachineRuleType.BASE
        ? `${row.prepayRate}%档位`
        : `${MachineRuleTypeToTextMap.get(row.ruleType)}类型`;
    },
    async confirmTip(row, target) {
      const res = await getMachineRuleStatusPrecheckAPI({
        id: row.id,
        status: target,
      });
      // 同组其他启用规则决定替换或停用后的空组提示。
      const others = (res && res.enabledRuleList) || [];
      const subject = this.confirmSubject(row);

      if (target) {
        return others.length
          ? `${subject}已有生效规则，启用后将自动停用原规则，是否确定？`
          : "";
      }
      return others.length
        ? ""
        : `停用后${subject}下将无生效规则，是否确定？`;
    },
    async submitStatus(row, status, tip) {
      try {
        await changeMachineRuleStatusAPI({ id: row.id, status });
        this.$message.success(tip);
        this.getList();
      } catch {
        row.status = !status;
      }
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  .el-divider--horizontal {
    margin: 0 0 20px;
  }

  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
}

.search-form-item {
  width: 220px;
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  .switch .el-switch__label--right {
    z-index: 1;
  }

  .switch .el-switch__label--right span {
    margin-left: 5px;
    margin-right: 10px;
  }

  .switch .el-switch__label--left {
    z-index: 1;
  }

  .switch .el-switch__label--left span {
    margin-left: 20px;
  }

  .switch .el-switch__label.is-active {
    display: block;
  }

  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
